<template>
  <v-container fluid>
    <v-row class="child-flex">
      <v-slide-y-transition mode="out-in">
        <TableCard
          v-model="tableData"
          :props-to-search="['name', 'dealer.name']"
          :table-columns="tableColumns"
          :actions="actions"
          @on-refresh="refreshList"
          :is-loading="isRefreshing"
          title="SQL Datasources"
          subtitle="Advanced Users Only. This Datasource has no guardrails."
        ></TableCard>
      </v-slide-y-transition>
    </v-row>
    <v-btn fab bottom right color="pink" dark fixed :to="{ 'name': 'new_sql_datasource_path' }">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { useSqlDatasource } from './sqlDatasourceComposable'
import TableCard from './TableCard.vue'

export default {
  setup (props, context) {
    const { sqlDatasources: tableData, isLoading: isRefreshing, fetchAll, deleteSqlDatasource } = useSqlDatasource()
    return {
      tableData,
      fetchAll,
      isRefreshing,
      deleteSqlDatasource
    }
  },
  components: {
    TableCard
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    ...mapState('ApplicationStore', ['dealerScopedView']),
  },
  data: function () {
    return {
      propsToSearch: ['name', 'dealer.name'],
      tableColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Dealer', value: 'dealer.name' },
        { text: 'Actions', value: 'actions' }
      ],
      actions: [
        { title: 'Edit', action: this.handleEdit, icon: 'mdi-pencil' },
        { title: 'Delete', action: this.handleDelete, icon: 'mdi-delete' }
      ]
    }
  },
  mounted: function () {
    this.$logger.trace('Mounted')
    return this.refreshList()
  },
  watch: {
    dealer: function (newDealer, oldDealer) {
      this.refreshList()
    },
    showTemplatesOnly: function (newVal, oldVal) {
      this.refreshList()
    }
  },
  methods: {
    refreshList () {
      const queryParams = this.dealerScopedView ? { dealer_id: this.dealer.id } : {}
      return this.fetchAll(queryParams)
        .catch(error => {
          this.$flash({
            showClose: true,
            message: 'Error Loading SQL Datasources. Reload to try again. ' + error.message,
            type: 'error'
          })
        })
    },
    handleDelete (row) {
      const shouldDelete = confirm('Are you sure you want to delete? This action can not be undone.')
      if (shouldDelete) {
        this.deleteSqlDatasource(row)
          .then(() => {
            this.refreshList()
            this.$flash({
              showClose: true,
              message: 'Deleted Datasource',
              type: 'mini',
              duration: 2000
            })
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error Deleting Datasource. ' + error.message,
              type: 'error',
              duration: 0
            })
          })
      }
    },
    handleEdit (item) {
      this.$router.push({ name: 'edit_sql_datasource_path', params: { id: item.id } })
      // this.$router.push({ name: 'edit_dms_datasource_path', params: { id: 544 } })
    }
  }
}
</script>
